import { createAction, props } from '@ngrx/store';
import {
  BillToAccounts,
  GetBillToAccountsParams,
  GetBrandBillingConfigParams,
} from '../../proto';

export enum BillingsActionTypes {
  BillToAccountsGet = '[Billings] BillToAccounts Get',
  BillToAccountsGetSuccess = '[Billings] BillToAccounts Get Success',
  BillToAccountsGetFailure = '[Billings] BillToAccounts Get Failure',
  BillToAccountsGetDestroy = '[Billings] BillToAccounts Get Destroy',
  BrandConfigBillingsGet = '[Billings] brand config Billing Get',
  BrandConfigBillingsGetSuccess = '[Billings] brand config Billing Get Success',
  BrandConfigBillingsGetFailure = '[Billings] brand config Billing Get Failure',
  BrandConfigBillingsGetDestroy = '[Billings] brand config Billing Destroy',
  BillingDestroy = '[Billings] Billing Destroy',
}

export const actionBillToAccountsGet = createAction(
  BillingsActionTypes.BillToAccountsGet,
  props<{ getBillToAccountsParams: GetBillToAccountsParams }>()
);

export const actionBillToAccountsGetSuccess = createAction(
  BillingsActionTypes.BillToAccountsGetSuccess,
  props<{
    billToAccounts?: BillToAccounts[];
    billToAccountsBrand?: BillToAccounts[];
  }>()
);

export const actionBillToAccountsGetFailure = createAction(
  BillingsActionTypes.BillToAccountsGetFailure
);

export const actionBillToAccountsGetDestroy = createAction(
  BillingsActionTypes.BillToAccountsGetDestroy
);

export const actionBrandConfigBillingsGet = createAction(
  BillingsActionTypes.BrandConfigBillingsGet,
  props<{ getBrandBillingConfigParams: GetBrandBillingConfigParams }>()
);

export const actionBrandConfigBillingsGetSuccess = createAction(
  BillingsActionTypes.BrandConfigBillingsGetSuccess,
  props<{ payload?: any }>()
);

export const actionBrandConfigBillingsGetFailure = createAction(
  BillingsActionTypes.BrandConfigBillingsGetFailure
);

export const actionBrandConfigBillingsGetDestroy = createAction(
  BillingsActionTypes.BrandConfigBillingsGetDestroy
);

export const actionBillingDestroy = createAction(
  BillingsActionTypes.BillingDestroy
);
